var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { updateDocument } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
import { PopupButton, PopupInput, PopupWindow } from "@/06-shared/ui/popups";
import styles from "./index.module.css";
export const RenameTreeNodePopup = ({ document, onProcessFinished = () => { }, }) => {
    const [isShown, setShown] = useState(false);
    const [newName, setNewName] = useState(document.title);
    const showError = useNotifyError();
    const openPopup = () => {
        setNewName(document.title);
        setShown(true);
    };
    const renameDocument = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield updateDocument({
                docId: document.id,
                name: newName,
            });
            setShown(false);
            onProcessFinished();
        }
        catch (error) {
            showError(error);
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx("button", Object.assign({ className: styles.actionButton, type: "button", onClick: (event) => {
                    event.stopPropagation();
                    openPopup();
                } }, { children: "[ren]" })), isShown ? (_jsxs(PopupWindow, Object.assign({ name: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C", onClose: () => setShown(false) }, { children: [_jsx(PopupInput, { name: "\u041D\u043E\u0432\u043E\u0435 \u0438\u043C\u044F", value: newName, setInput: setNewName, onEnter: renameDocument, autoFocus: true }), _jsx(PopupButton, { name: "[Ok]", onClick: renameDocument })] }))) : null] }));
};
